import _ from 'lodash';

// Only a Borrower-assigned library task can be re-bound at the gate — an
// SLA-group / entity task resolves its owner from config, so it gets no picker.
export const getEditableTasks = (tasks = []) =>
  tasks.filter(task => task.isBorrowerAssigned && !_.isNil(task.taskTypeId));

// Seed the per-task assignee draft (taskTypeId -> assigneeId) when entering
// edit: a previously-saved edit wins so re-opening the row shows the operator's
// choice; otherwise the model's proposed assignee.
export const buildInitialTaskAssignees = (editableTasks = [], savedEditedTasks = null) => {
  const savedByTaskType = _.keyBy(savedEditedTasks ?? [], 'taskTypeId');

  return editableTasks.reduce((acc, task) => {
    const saved = savedByTaskType[task.taskTypeId];

    acc[task.taskTypeId] = saved ? (saved.assigneeId ?? null) : (task.assigneeId ?? null);

    return acc;
  }, {});
};

// Overlay a saved assignee edit onto the display tasks so the collapsed card
// shows the operator's chosen assignee (mirroring how edited text shows) rather
// than the model's original binding. Untouched when nothing was edited.
export const buildDisplayTasks = (tasks = [], savedEditedTasks = null, borrowerOptions = []) => {
  if (_.isEmpty(savedEditedTasks)) {
    return tasks;
  }

  const editedByTaskType = _.keyBy(savedEditedTasks, 'taskTypeId');
  const optionsById = _.keyBy(borrowerOptions, 'id');

  return tasks.map(task => {
    const edited = editedByTaskType[task.taskTypeId];

    if (!edited) {
      return task;
    }

    const assigneeName = edited.assigneeId ? (optionsById[edited.assigneeId]?.name ?? null) : null;

    return { ...task, assigneeId: edited.assigneeId ?? null, assigneeName };
  });
};

// Project the assignee draft back to the decision payload shape the backend
// re-binding contract expects. Null when the condition has no reassignable task.
export const buildEditedTasks = (editableTasks = [], taskAssigneeDraft = {}) =>
  editableTasks.length > 0
    ? editableTasks.map(task => ({
        taskTypeId: task.taskTypeId,
        assigneeId: taskAssigneeDraft[task.taskTypeId] ?? null,
      }))
    : null;
